import { render } from "./ViewProgram.vue?vue&type=template&id=77b0d664&scoped=true"
import script from "./ViewProgram.vue?vue&type=script&lang=js"
export * from "./ViewProgram.vue?vue&type=script&lang=js"

import "./ViewProgram.vue?vue&type=style&index=0&id=77b0d664&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77b0d664"]])

export default __exports__